<template>
  <div
    class="cv-wrapper"
    :class="{ 'page-loading-wrapper': pageLoadingShow }"
    :style="isWxMini ? { paddingBottom: 0 } : {}"
    v-show="loadingPageOver"
  >
    <!--    <div class="flex-between has-mentor" v-if="mentorOrderData.count">-->
    <!--      <div class="flex-start">-->
    <!--        <img src="https://files.wondercv.com/red-alert.png" alt="">-->
    <!--        <span class="has-mentor-text">简历修改服务信息未完善</span>-->
    <!--      </div>-->
    <!--      <button class="theme-button flex-center" @click="consummate">立即完善</button>-->
    <!--    </div>-->
    <div
      class="cv-description flex-center"
      v-show="
        !isReviewOfIos &&
        userStatusShow &&
        !isQQMini &&
        !isBaidu &&
        !mentorOrderData.count &&
        logged
      "
      @click.stop="freeMemberClick"
    >
      <!-- 下边判断故意加的false，暂时隐藏掉 -->
      <div
        class="cv-msg flex-between"
        v-if="
          !userData.is_membership &&
          !isAlipayClient &&
          !isUCClient &&
          !isQuaReClient &&
          false
        "
      >
        <div class="flex-start">
          <span class="iconfont iconx" @click.stop="userStatusShow = false" />
          <img
            src="https://files.wondercv.com/mobile/m_cvs_member.png"
            alt=""
          />
          <span class="not-member-text">分享免费获得超级会员</span>
        </div>
        <button class="member-btn theme-button">立即升级</button>
      </div>
      <div
        class="cv-msg flex-between"
        v-else-if="userData.is_membership && residueTime < 8"
      >
        <p class="flex-start">
          <span
            class="iconfont iconx"
            @click="userStatusShow = false"
            style="margin-right: 10px"
          ></span>
          <span class="high-light">
            {{
              residueTime === 0
                ? `您的会员今天到期，点击续费`
                : `您的会员还有${residueTime}天到期，点击续费`
            }}
          </span>
        </p>
        <button class="member-btn theme-button" @click="editClick('member')">
          立即续费
        </button>
        <!--        <p class="flex-start">-->
        <!--          -->
        <!--        </p>-->
      </div>
    </div>
    <div class="banner-container" v-show="showBanner">
      <banner @hidBanner="hidBanner" />
    </div>
    <!-- 金刚区 -->
    <goodLocation :isStudent="userData.is_student"></goodLocation>
    <div class="cv-operation" v-if="!pageLoadingShow">
      <cv-operation
        :isLogin="logged"
        :onlineCvToken="onlineCvToken"
        :onlineCvTime="onlineCvTime"
        @setOnlineCv="setOnlineCv"
        @showCvsRecommend="showCvsRecommend"
        @goEditor="toCvShow"
        @operation="operation"
        @addCv="addCv"
      />
      <div class="banner" v-if="cvs_banner.image">
        <a @click="$fn.jump(cvs_banner.link)">
          <img :src="cvs_banner.image" />
        </a>
      </div>
    </div>
    <div class="cv-container">
      <div v-if="pageLoadingShow" class="cv-loading-wrapper flex-center">
        <img src="https://files.wondercv.com/mobile/cvs/loading.gif" alt="" />
      </div>
      <template v-else>
        <recommend-temps
          :recommendTemps="recommendTemps"
          @changeScaleStatus="changeScaleStatus"
          @cvByTemp="cvByTemp"
          v-if="logged && cvList.length === 0"
        />
        <!-- <community v-if="logged && cvList.length > 0" /> -->
        <cv-templates
          :isLogin="logged"
          :cvList="cvList"
          @useTemp="_useTemp"
          :templateCase="templateCase"
          :tags="tags"
        />
        <!--        <cv-actions v-if="!cvList.length || !iosOrAndroidShow"/>-->
        <cv-recommend v-if="cvList.length && iosOrAndroidShow && !isHarmony" />
      </template>
      <div class="cv-add flex-center" v-show="!showImport" @click="addCv">
        <span class="iconfont iconplus2"></span>
      </div>
    </div>
    <!--    <div class="import-mask" v-show="importMaskShow">-->
    <!--      <div class="import-content flex-center">-->
    <!--        <img src="https://files.wondercv.com/mobile/cvs/import-arrow.png" alt="">-->
    <!--        <p>已有简历可直接导入，<br>免费智能诊断简历问题！</p>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="setting-mask" v-show="cvSetShow">-->
    <!--      <div class="cv-set-content flex-start">-->
    <!--        <img src="https://files.wondercv.com/mobile/cvs/import-arrow.png" alt="">-->
    <!--        <p>HR可见简历移到这里啦，<br>查看更方便~</p>-->
    <!--      </div>-->
    <!--    </div>-->
    <cvs-recommend
      :onlineCvToken="onlineCvToken"
      :onlineCvTime="onlineCvTime"
      @closeCvRecommend="closeCvRecommend"
      @goEditor="toCvShow"
      @setOnlineCv="setOnlineCv"
      @operation="operation"
      @addCv="addCv"
      v-show="cvsRecommendState"
    />
    <div
      v-show="importMaskShow || createShow || cvSetShow"
      class="mask"
      @touchmove.prevent
      @click="closeMask"
    ></div>
    <use-temp
      :state="useTempState"
      :isLogin="logged"
      :template-info="templateInfo"
      :bar="true"
      @useTemp="_useTemp"
      @handleClose="useTempState = false"
    />
    <cv-scale
      :state="scaleShow"
      :scaleTemp="scaleTemp"
      @cvByTemp="cvByTemp"
      @handleClose="scaleShow = false"
    />
    <name-privacy
      :setting-show="settingShow"
      :cv-data="cv"
      @handleClose="settingShow = false"
      @refresh="refresh"
    />
    <free-member
      :state="freeMemberShow"
      @handleClose="freeMemberShow = false"
    />
    <!-- <upper-limit-cv :state="continueShow" @handleClose="continueShow = false"/> -->
    <edit-dialog
      :state="editShow"
      :editType="editType"
      :selectOption="selectOption"
      :current-cv-data="cv"
      @refresh="refresh"
      @handleClose="editShow = false"
    />
    <online-cv
      :state="onlineCvState"
      @handleClose="onlineCvState = false"
      @setOnlineCv="setOnlineCv"
    />
    <w-loading v-show="loadingShow" :show-text="true" />
    <w-tabbar v-show="iosOrAndroidShow" :page="'cv'" />
    <update-version :state="isIos"></update-version>
    <w-popup :state="showImport" @handleClose="closeImportMask">
      <new-cv
        slot="content"
        :state="showImport"
        @close="closeImportMask"
        @addOrImportCv="addOrImportCv"
      />
    </w-popup>
    <w-popup :state="operationPickerState" @handleClose="closeImportMask">
      <operation-picker
        slot="content"
        :pickerData="pickerData"
        :state="operationPickerState"
        @operation="pickerChange"
        @close="closeImportMask"
      />
    </w-popup>
    <!-- app专项福利 -->
    <cube-popup
      :visible="
        showDownAppImg && !isAlipayClient && !isUCClient && !isQuaReClient
      "
      type="my-popup"
      ref="downloadPopup"
    >
      <img
        @click="toDowndload"
        class="download-img"
        src="https://files.wondercv.com/download/m_downLoad.png"
        alt=""
      />
      <div class="close-icon">
        <i @click="showDownAppImg = false" class="iconfont iconGroup10"></i>
      </div>
    </cube-popup>
    <!-- <member-dialog :state="memberDialogVisible" @handleClose="memberDialogVisible = false"/> -->
    <!-- 购买会员弹窗 -->
    <w-popup
      :state="memberDialogVisible"
      @handleClose="memberDialogVisible = false"
    >
      <operation-vip slot="content" />
    </w-popup>

    <!--    <div style="position:fixed;right:24px;bottom:122px;display:flex;flex-direction:column;align-items:flex-end;" @click="toHackthon">-->
    <!--      <div><img src="../hackthon/image/11.png" alt="" srcset="" style="width:134px;height:31px;"></div>-->
    <!--      <div><img src="../hackthon/image/12.png" alt="" srcset="" style="width:60px;height:60px;margin-top:10px;"></div>-->
    <!--    </div>-->
    <!-- 为支付宝直接登录 -->
    <div
      class="show-alipay-login-model"
      v-if="showAlipayLoginModel"
      @click.stop="
        navigateAlipayMiniTo({
          url: `/pages/login/login?channel=${
            $route.query.channel || ''
          }&authorizePage=true`,
        })
      "
    ></div>

    <!-- 购买会员弹窗 -->
    <w-popup :state="continueShow" @handleClose="continueShow = false">
      <operation-vip slot="content" />
    </w-popup>

    <!--    广告弹窗-->
    <cube-popup
      :visible="advBannerState && isWxMini"
      type="my-popup"
      ref="advPopup"
    >
      <img
        @click="toAdvBannerLink()"
        class="download-img"
        :src="advBanner.image"
        alt=""
      />
      <div class="close-icon">
        <i @click="advBannerState = false" class="iconfont iconGroup10"></i>
      </div>
    </cube-popup>
    <!--    <w-popup :state="advBannerState" @handleClose="advBannerState = false">-->
    <!--      <div class="adv-banner-container" slot="content">-->

    <!--      </div>-->
    <!--    </w-popup>-->
  </div>
</template>

<script>
import publicCv from "./public-cv";
import cvActions from "./cv-actions";
import cvRecommend from "./cv-recommend";
import WTabbar from "../../components/global/w-tabbar";
import CvScale from "../cv-components/cv-scale";
import namePrivacy from "../cv-components/name-privacy";
import payDialog from "../../components/ios/pay-dialog";
import freeMember from "../cv-components/free-member";
// import upperLimitCv from '../cv-components/upper-limit-cv'
import operationVip from "../cv-components/operation-vip.vue";
import changeStatus from "../cv-components/change-cv-status";
import editDialog from "../cv-components/edit-dialog";
import WLoading from "../../components/global/w-loading";
import useTemp from "../cv-components/use-temp";
import onlineCv from "../cv-components/online-cv-dialog";
import morePublicCv from "../cv-components/more-public-cv";
import updateVersion from "../../components/ios/update-version";
import Banner from "./components/banner"; // banner 图组件
import CvOperation from "./components/cvOperation"; // 简历卡片组件
import CvTemplates from "./components/cvTemplates"; // 简历模板组件
import RecommendTemps from "./components/recommendTemps"; // 推荐模板组件
import WPopup from "@/components/global/w-popup";
import NewCv from "./components/newCv"; // 导入或者新建简历弹窗组件
// import Community from './components/community'   // 帖子（讨论组件）
import CvsRecommend from "./components/cvsRecommend"; // 我的简历组件
import WechatOpenSubscribe from "../../components/wechat-open-subscribe/wechat-open-subscribe";
import OperationPicker from "./components/operationPicker";
import memberDialog from "@/components/user/member-dialog";
import goodLocation from "./components/goodLocation"; // 金刚区
import {
  templateMixin,
  onlineMixin,
  cvOperationMixin,
} from "../../assets/js/mixin/cv";
import { userMixin } from "../../assets/js/mixin/user";
import { envMixin, loginMixin } from "../../assets/js/mixin/global";
import { componentsMixin } from "../../assets/js/mixin/components";
import {
  checkJWT,
  setupWebViewJavascriptBridge,
  updateJWT,
} from "../../assets/js/utils";
import { mapActions, mapState, mapMutations } from "vuex";
import { temps, recommendTemps } from "../../assets/json/temps";

let moment = require("moment");
const ADV_LIMIT = 60 * 60 * 24;
import Cookies from "js-cookie";

export default {
  mixins: [
    templateMixin,
    componentsMixin,
    onlineMixin,
    envMixin,
    loginMixin,
    userMixin,
    cvOperationMixin,
  ],
  data() {
    return {
      logged: false, // 是否登录
      showDownAppImg: false, // 下载app弹框
      freeMemberShow: false, // 免费分享会员弹窗
      editShow: false, // 会员到期选择简历继续编辑弹窗
      moreCvState: false, // 简历列表更多按钮
      continueShow: false, // 简历已达上限开通会员弹窗
      changeStatusShow: false, // hr申请查看 删除或者更改私密度弹窗
      settingShow: false, // 简历设置弹窗
      scaleShow: false, // 已登录无简历 简历模板放大按钮弹窗
      onlineCvState: false, // 在线简历弹窗
      editType: "", // 当前用户是免费选择简历继续编辑还是升级会员 selectCv： 选择简历 member： 升级会员
      selectOption: [], // 选择简历的option
      applyCount: 0, //  简历申请查看总条数
      count: 0, // 新增简历申请查看条数
      req: {}, // 选择简历继续编辑的 payload
      scaleTemp: {}, // 已登录无简历当前被放大的简历模板
      templateCase: {}, // 未登录大牛案例模板
      cv: {}, // 当前操作的cv数据
      cvsData: {}, // 已登录请求的cv数据
      temps, // 未登录8个推荐模板,
      recommendTemps: [],
      residueTime: 0, // 会员倒计时时间
      cvInfo: {}, // hr申请查看 删除或者更改私密度当前简历的数据,
      importMaskShow: false, // 导入简历蒙版
      cvSetShow: false, // 在线简历蒙版
      loadingShow: false, // 简历部分的loading
      userStatusShow: false, // 头部文案的显示
      onlineVersionShow: false, // 在线简历ios弹窗
      loadingOver: false, // 在线简历卡片请求数据后
      createShow: false, // 有简历创建简历的小弹窗
      mentorOrderData: {}, // 未完善的导师订单
      importCvShow: false, // 用户是否使用过导入简历
      pageLoadingShow: true, // 页面加载时候的loading
      pickerData: [], // 简历操作功能列表
      // ios相关内容
      imgSrc: "https://files.wondercv.com/mobile/cvs/ios-pay-member.png", // ios版本更新弹窗icon
      payDialogShow: false, // ios不能支付弹窗
      descriptionInfo: [
        // ios版本更新弹窗介绍
        "享受超级简历所有特权",
        "AI 简历助手 智能改简历",
        "无限使用大牛模板案例",
        "帮你大幅提升求职成功率",
      ],
      showImport: false, // 新建/导入简历弹窗状态
      cvsRecommendState: false, // 推荐简历弹窗开关
      operationPickerState: false, // 简历操作弹窗开关
      showBanner: true,
      memberDialogVisible: false,
      showAlipayLoginModel: false, // 支付宝登录弹窗
      advBanner: {
        image: "",
        link: "",
      }, // 广告配置
      advBannerState: false, // 广告开关
      cvs_banner: {},
    };
  },
  async created() {
    // 微信小程序根据unionid自动登录
    // 各种小程序根据jwt&&jwt_timestamp 自动登录
    await this.miniprogramAutoLogin();
    await this.verifyLogged();

    let UA = navigator.userAgent.toLocaleLowerCase() || "";
    let isLogin = !!Cookies.get("_t");
    // 监听是否是超级课程表 && !登录
    if (UA.includes("superfriday") && !isLogin) {
      this.superFriday();
    }
    console.log(this.$route.query, "query");
    // 从大牛简历小程序进入
    if (this.$route.query.canCreateResume === "false") {
      this.showToast("已超出简历上限,建议开通会员或删除多余简历");
    }
    // 跳转到cvs页的回调方法
    this.callbackFunc();
    this.cvsRecommendState = this.$route.query.cvsRecommendState === "true";
    this.changeExperienceEnter(false);
    // 清除online cv 中的基本信息
    this.changeOnlineCvBasic({});
    // 登录错误，小程序自动登录，校验是否登录
    this.loginErr();
    await this.initData();
    this.setEditCvAfterMemberOver();
    this.verifyOnlineCv();
    // 遮罩层显示规则
    this.maskShow();
    // 获取所有申请的
    this._getAllApply();
    // 是否显示app下载弹框
    //this.isShowDownload()
    // this.dealPrivacy()
    // await this.oldUserInfoCollect()
    this.getAdvBanner();
    this.getCvsBanner();

    if (!this.logged && this.isAlipayClient) {
      this.showAlipayLoginModel = true;
    }
    let useTemplate = this.$db.ls.get("useTemplate");
    let newAccount = this.$db.ls.get("newAccount");
    if (useTemplate && newAccount) {
      this.$db.ls.remove("useTemplate");
      this.$fn.jump(`${window.location.origin}/cvs/${useTemplate}/editor`, () => {
        this.$router.push(`/cvs/${useTemplate}/editor`);
      })
    }
    this.$db.ls.remove("newAccount");
  },
  mounted() {
    if (!this.isWxMini) return;
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        if (!Cookies.get('_t')) return;
        this.initData()
      }
    });
  },
  components: {
    cvActions,
    cvRecommend,
    WTabbar,
    CvScale,
    namePrivacy,
    payDialog,
    changeStatus,
    freeMember,
    // upperLimitCv,
    operationVip,
    editDialog,
    useTemp,
    publicCv,
    onlineCv,
    WLoading,
    morePublicCv,
    updateVersion,
    closeUpdateVersion: updateVersion,
    Banner,
    CvOperation,
    CvTemplates,
    RecommendTemps,
    WPopup,
    NewCv,
    // Community,
    CvsRecommend,
    OperationPicker,
    memberDialog,
    goodLocation,
    WechatOpenSubscribe,
  },
  watch: {},
  computed: {
    ...mapState("cv", [
      "applies",
      "onlineCvData",
      "onlineVisibility",
      "onlineCvValid",
    ]),
    ...mapState("cvIndex", ["cvList", "templateCvs"]),
    ...mapState("user", ["userData"]),
    cvStatusText() {
      return this.cv.visibility === "in_public"
        ? "公开"
        : this.cv.visibility === "hr_visible"
        ? "对 HR 可见"
        : "私密";
    },
    cvOperation() {
      return [
        { id: 1, title: "新建简历", subTitle: "立即制作优质简历" },
        { id: 2, title: "导入简历", subTitle: "上传简历智能优化" },
      ]; // header简历的操作
    },
    purpose() {
      if (this.isBaidu) {
        return [
          {
            id: 2,
            img: "https://files.wondercv.com/mobile/cvs/email-banner.png",
            url: `/service`,
          },
        ];
      } else {
        return [
          {
            id: 1,
            img: "https://files.wondercv.com/mobile/cvs/strategy-banner.png",
            url: `/blog`,
          },
          {
            id: 2,
            img: "https://files.wondercv.com/mobile/cvs/email-banner.png",
            url: `/service`,
          },
        ];
      }
    },
    // 在线简历设置提示框
    onlineState() {
      let cnCvs = this.cvList
        ? this.cvList.filter(
            (item) => item.lang === "cn" && !item.is_mentor && item.can_editable
          )
        : [];
      return cnCvs.length;
    },
    // 是否有在线简历
    hasOnlineCv() {
      if (this.onlineCvData) {
        return Object.keys(this.onlineCvData).length;
      }
    },
    // 在线简历更新时间，判断是否显示在线简历遮罩层
    onlineCvTime() {
      if (this.onlineCvData && !this.onlineVisibility) {
        // return moment(this.onlineCvData.resume.updated_at).format('YYYYMMDDHHmmss')
        return this.onlineCvData.resume?.updated_at;
      } else if (this.onlineCvData.updated_at) {
        // return moment(this.onlineCvData.updated_at).format('YYYYMMDDHHmmss')
        return this.onlineCvData?.updated_at;
      }
    },
    // 在线简历的token
    onlineCvToken() {
      if (this.hasOnlineCv) {
        if (this.onlineCvData.resume) {
          return this.onlineCvData.resume.token;
        } else if (this.onlineCvData.token) {
          return this.onlineCvData.token;
        }
      }
    },

    // 推荐简历模板数组
    recTemps() {
      return recommendTemps;
    },
    // 未登录tags
    tags() {
      return [
        {
          cn: "互联网",
          en: "hulianwang",
        },
        {
          cn: "金融",
          en: "jinrong",
        },
        {
          cn: "咨询",
          en: "zixun",
        },
        {
          cn: "银行",
          en: "yinhang",
        },
      ];
    },
  },
  methods: {
    ...mapActions("cv", [
      "getCvApplies",
      "getOnlineCvData",
      "getVisibility",
      "checkCvValid",
    ]),
    ...mapActions("cvIndex", ["getCvList", "getTemplateCv"]),
    ...mapMutations("cv", ["changeCvData", "changeOnlineCvBasic"]),
    ...mapMutations("cvIndex", ["changeCvList"]),
    ...mapMutations("cvExperience", ["changeExperienceEnter"]),
    ...mapMutations("user", ["setIsNeedResume"]),
    async initData() {
      // 获取大牛案例
      this._getTemplateCase();
      // 已登录获取用户信息
      this.getUserStatus();
      // 获取cvList, 获取在线简历
      await this._getCvsData();
      await this._getOnlineCvData();
    },
    toAdvBannerLink() {
      console.log(this.advBanner, "================>lalala");
      // window.open(this.advBanner.link)
      location.href = this.advBanner.link;
    },
    async getCvsBanner() {
      try {
        let res = await this.$api.jobs.getBannerImg({ position: 126 });
        if (res.code === 1000) {
          if (res.data.length > 0) {
            this.cvs_banner = res.data[0];
            console.log(this.cvs_banner);
          }
        }
        // this.oldUserInfoCollect()
      } catch (e) {
        console.log(e);
      }
    },
    async getAdvBanner() {
      this.$db.ls.remove("advBanner");
      let historyBannerTimer = this.$db.ls.get("historyCvsBannerState");
      let currentDateString = new Date().toLocaleDateString();
      let [beforeMinus, afterMinus = 0] = (historyBannerTimer || "").split("-");
      try {
        let res = await this.$api.jobs.getBannerImg({ position: 81 });
        console.log(res, "===================》resss");
        if (res.code === 1000 && res.data.length) {
          const isDiffDate = beforeMinus !== currentDateString;
          isDiffDate && (afterMinus = 0);
          const isBannerState =
            isDiffDate || (!isDiffDate && +afterMinus < res?.data?.length);

          if (isBannerState) {
            this.advBanner = res.data[afterMinus];
            this.advBannerState = true;
            afterMinus = +afterMinus + 1;
            this.$db.ls.set(
              "historyCvsBannerState",
              `${currentDateString}-${afterMinus}`
            );
          } else {
            return console.log(res);
          }
        }
        this.oldUserInfoCollect();
      } catch (e) {
        console.log(e);
      }
    },
    callbackFunc() {
      const { type, code } = this.$route.query;
      if (type && type === "importCv") {
        if (code === "3000") {
          this.showToast("已达简历数量上限");
        } else if (code === "3001") {
          this.showToast("已达简历上限，升级会员可创建多份简历");
          this.memberDialogVisible = true;
        }
      }
    },
    // 获取在线简历相关数据
    toHackthon() {
      this.$router.push("/interview/index");
    },
    // banner图数据为空时隐藏banner区域
    hidBanner() {
      this.showBanner = false;
    },
    // 显示设置在线简历弹窗
    showCvsRecommend() {
      this.$fn.jump(
        `${window.location.origin}/cvs?cvsRecommendState=true`,
        () => {
          this.$router.replace({
            path: "/cvs",
            query: { cvsRecommendState: true },
          });
          this.cvsRecommendState = true;
        }
      )
    },
    // 关闭设置在线简历弹窗
    closeCvRecommend() {
      this.$router.replace({
        path: "/cvs",
        query: { cvsRecommendState: false },
      });
      this.cvsRecommendState = false;
    },
    // 关闭新建/导入简历弹窗
    closeImportMask() {
      this.showImport = false;
      this.operationPickerState = false;
    },
    closeDownload() {
      this.showDownAppImg = true;
    },
    // 显示下载app弹框
    isShowDownload() {
      if (!localStorage.getItem("showDownload") && this.logged) {
        localStorage.setItem("showDownload", true);
        this.showDownAppImg = true;
      }
    },
    toDowndload() {
      window.location.href = `${process.env.VUE_APP_HOST}/welcome/to_app?type=other`;
    },
    async _getOnlineCvData() {
      if (this.logged) {
        try {
          await Promise.all([
            this.getOnlineCvData(this.cvAccountToken),
            this.getVisibility(this.cvAccountToken),
          ]);
          let list = this.cvList.filter(
            (item) => item.lang === "cn" && !item.is_mentor && item.can_editable
          );
          let token = this.onlineCvData.resume
            ? this.onlineCvData.resume.token
            : this.onlineCvData.token;
          if (list && list.length && list.find((item) => item.token === token))
            await this.checkCvValid(token);
          this.loadingOver = true;
          this.pageLoadingShow = false;
        } catch (error) {
          console.log(error);
        }
      }
    },
    // 会员过期设置在线简历
    setEditCvAfterMemberOver() {
      if (this.logged) {
        const memberOver = this.cvList.every((item) => !item.can_editable);
        const index = this.cvList.findIndex(
          (item) => item.token === this.onlineCvToken
        );
        if (memberOver && !this.onlineVisibility && index > -1) {
          this.$api.cv
            .editableCv({
              lang: "cn",
              token: this.onlineCvToken,
            })
            .then((res) => {
              if (res.code === 1000) {
                this.getCvList({ page: 1, page_size: 20 });
                // this.cvList[index].can_editable = true
              }
            });
        }
      }
    },
    // 遮罩层的显示规则
    maskShow() {
      let notExport = this.$db.ls.get("notExport");
      let notSet = this.$db.ls.get("notSet");
      let diffTime = 31;
      if (this.$db.ls.get("preTime"))
        diffTime = moment().diff(this.$db.ls.get("preTime"), "minute");
      if (
        !this.versionShow &&
        diffTime >= 30 &&
        !this.isReviewOfIos &&
        this.logged &&
        !this.onlineCvState
      ) {
        if (!notSet && this.hasOnlineCv && this.onlineCvTime < "20200408") {
          this.cvSetShow = true;
          this.$db.ls.set("notSet", true);
          this.$db.ls.set("preTime", moment());
        } else if (
          this.importCvShow &&
          this.cvList &&
          !this.cvList.length &&
          !notExport
        ) {
          this.importMaskShow = true;
          this.$db.ls.set("notExport", true);
          this.$db.ls.set("preTime", moment());
        }
      }
    },
    //  校验是否弹出设置在线简历弹窗
    verifyOnlineCv() {
      let onlineDialogShow = this.$db.ls.get("onlineDialogShow");
      if (
        this.logged &&
        this.onlineState &&
        !onlineDialogShow &&
        !this.hasOnlineCv &&
        !this.onlineVisibility
      ) {
        this.onlineCvState = true;
        this.$db.ls.set("onlineDialogShow", true);
      }
    },
    // 有草稿简历新建简历
    changeCreateShow() {
      this.createShow = !this.createShow;
    },
    // 设置在线简历判断跳转逻辑
    setOnlineCv() {
      let length = Object.keys(this.userData);
      if (length && (!this.userData.match || !this.userData.intention)) {
        let url = !this.userData.match
          ? "/template_matches/new"
          : "/job/intentions";
        this.setIsNeedResume(true);
        this.$fn.jump(`${window.location.origin}${url}`, () => {
          this.routeTo(url);
        })
      } else if (this.draftCvList.length === 1) {
        this.nextStep();
      } else {
        this.$fn.jump(
          `${window.location.origin}/cvs/online/list`,
          () => {
            this.routeTo(`/cvs/online/list`);
          }
        )
      }
    },
    editClick() {
      if (this.$isWxMini) {
        // this.$wechat.miniProgram.navigateTo({ url: '/pages/customService/customService' })
        this.$wechat.miniProgram.navigateTo({ url: "/pages/member-buy/index" });
      } else {
        // this.$api.user.createImprovedOrder(
        // 	{
        // 		from_vue: 'true',
        // 		improved_order: { package: 'membership' }
        // 	}).then(res => {
        // 	if (res.code === 1000) {
        // 		window.location.href = process.env.VUE_APP_LINK + `/orders/${ res.data.order_token }`
        // 	}
        // })
        this.$router.push({ path: "/buy/member/order" });
      }
    },
    // 关闭遮罩层
    closeMask() {
      this.importMaskShow = false;
      this.createShow = false;
      this.cvSetShow = false;
    },
    // 错误返回cvs的提示
    loginErr() {
      if (this.$db.ls.get("loginErr") && !this.isIos) {
        this.showToast("没有查看权限，请登录正确的账号再次尝试", 1500);
        this.$db.ls.remove("loginErr");
      }
    },
    // 获取cvs数据
    async _getCvsData() {
      if (this.logged) {
        await this.getCvList({ page: 1, page_size: 20 });
        // if (!this.cvList.length) {
        // 	this.getRecommendTemps()
        // }
      }
    },
    // 已登录无简历获取推荐模板
    async getRecommendTemps() {
      let recommendTemps = [];
      this.getTemplateCv();
      let res = await this.$api.cv.getRecommendTemplate(this.cvAccountToken);
      if (res.code === 1000) {
        recommendTemps = this.recTemps.filter((i) =>
          res.data.names.includes(i.cv_type)
        );
        recommendTemps.forEach((item) => {
          if (item.cn_img) {
            item.currentLang = "cn";
          } else {
            item.currentLang = "en";
          }
        });
        this.recommendTemps = recommendTemps;
      }
    },
    // 判断是否登录
    async verifyLogged() {
      if (Cookies.get("_t") || Cookies.get("_t_plugin")) {
        this.logged = true;
      }
    },
    // 获取用户信息
    async getUserStatus() {
      if (this.logged) {
        await this.getUserData();
        if (!this.userData.match && !this.userData.intention && this.isWxMini) {
          this.$router.push({
            path: "/template_matches/new",
            query: { notIcon: 1 },
          });
        } else {
          const [mentor, tipTop] = await Promise.all([
            this.$api.user.getUserMentorOrder(),
            this.$api.user.getUserImportCv(
              { check_type: "need_cvs_top_tip" },
              this.cvAccountToken
            ),
          ]);
          if (mentor.code === 1000) {
            this.mentorOrderData = mentor.data;
          }
          if (tipTop.code === 1000) {
            this.importCvShow = tipTop.data.need_top_tip;
          }
          if (this.userData.is_membership) {
            this.residueTime = moment(this.userData.membership_expired_at).diff(
              moment(),
              "days"
            );
          }
          this.userStatusShow = true;
        }
      } else {
        this.userStatusShow = true;
      }
    },
    // 判断是否有待完善的导师辅导简历
    consummate() {
      if (this.mentorOrderData.count === 1) {
        window.location.href = `/service/pay_success/${this.mentorOrderData.first_order_token}?source=cv`;
      } else if (this.mentorOrderData.count > 1) {
        this.$router.push("/account/orders");
      }
    },
    // 免费会员分享弹窗
    freeMemberClick() {
      if (this.isWxMini) {
        if (this.mobileOS === "iOS") {
          this.$wechat.miniProgram.navigateTo({
            // url: `/pages/customService/customService`
            url: `/pages/memberPay/memberPay`,
          });
        } else {
          this.$router.push("/buy/member/order");
        }
      } else {
        // 支付宝小程序不显示微信二维码弹窗
        if (!this.isAlipayClient && !this.isUCClient && !this.isQuaReClient) {
          this.freeMemberShow = true;
        }
      }
    },
    // 添加或者导入简历事件处理
    addOrImportCv(type) {
      switch (type) {
        case "template": {
          // this.verifyLogin(this.logged, () => {
          //   this.$router.push('/cvs/templates')
          // }, `/cvs/templates`)
          this.verifyLogin(
            this.logged,
            () => {
              this.$fn.jump(`${window.location.origin}/jianlimoban/cv/`)
            },
            `/jianlimoban/cv/`
          );
          break;
        }
        case "import": {
          this.verifyLogin(
            this.logged,
            () => {
              this.$fn.jump(`${window.location.origin}/welcome/mobile_import_cv_index`)
            },
            `/welcome/mobile_import_cv_index`
          );
          break;
        }
      }
    },
    // 添加或者导入简历时显示弹窗
    addCv(item) {
      this.showImport = true;
      // if (item.id === 3) {
      //   window.location.href = `/jianlimoban/tuijian/`
      // } else if (item.id === 1) {
      // 	this.verifyLogin(this.logged, () => {
      // 		this.$router.push('/cvs/templates')
      // 	}, `/cvs/templates`)
      // } else {
      // 	this.verifyLogin(this.logged, () => {
      // 		window.location.href = '/welcome/mobile_import_cv_index'
      // 	}, `/welcome/mobile_import_cv_index`)
      // }
    },
    // // 切换中英文模板
    // changeTemp (type, temp) {
    // 	temp.currentLang = type
    // },
    // 控制简历模板上面的使用按钮
    // changeTemplateUse (temp) {
    // 	temp.use = !temp.use
    // 	this.$forceUpdate()
    // },
    // 跳转到申请简历查看页面
    toInbox() {
      this.$router.push("/inbox");
    },
    // 编辑简历弹窗
    async toCvShow(cv) {
      this.cv = cv;
      if (cv.can_editable) {
        this.$fn.jump(`${window.location.origin}/cvs/${cv.token}/editor`,
        () => {
          this.$router.push(`/cvs/${cv.token}/editor`);
        });
      } else {
        await this._dealOptions();
        this.editShow = true;
      }
    },
    // 编辑简历是判断当前是否可全部都能编辑
    _dealOptions(type) {
      const editAry = this.cvList.filter(
        (v) => v.can_editable && v.lang === this.cv.lang && !v.is_mentor
      );
      if (type === "selectCv" || !editAry.length) {
        this.selectOption = [
          {
            title: "中文简历",
            field: "cn_token",
            options: this.cvList
              .filter((item) => item.lang === "cn" && !item.is_mentor)
              .map((v) => {
                return { name: v.cv_name, value: v.token };
              }),
          },
          {
            title: "英文简历",
            field: "en_token",
            options: this.cvList
              .filter((item) => item.lang === "en")
              .map((v) => {
                return { name: v.cv_name, value: v.token };
              }),
          },
        ];
        this.editType = "selectCv";
      } else {
        this.editType = "member";
      }
    },
    // 点击操作按钮
    operation(cv) {
      this.cv = cv;
      this.pickerData = [];
      if (!cv.can_editable) {
        const editCvAry = this.cvList.filter(
          (item) =>
            item.lang === cv.lang &&
            item.token !== cv.token &&
            item.can_editable
        );
        if (editCvAry.length) {
          this.pickerData = [
            // { text: '继续编辑', value: 'continue' },
            { text: "下载", value: "download", icon: "icondownload" },
            { text: "删除", value: "delete", icon: "iconshanchujianli" },
          ];
        } else {
          this.pickerData = [
            {
              text: "选择简历",
              value: "select",
              icon: "iconhebingzhongyingjianli",
            },
            { text: "下载", value: "download", icon: "icondownload" },
            { text: "删除", value: "delete", icon: "iconshanchujianli" },
          ];
        }
      } else if (cv.is_mentor) {
        this.pickerData = [
          // { text: '导师辅导中', value: 'cv' },
          {
            text: "修改简历名称",
            value: "setting",
            icon: "iconxiugaijianlimingcheng",
          },
          { text: "复制", value: "copy", icon: "iconfuzhijianli" },
          // { text: '预览分享', value: 'share' },
          // { text: '投递邮件', value: 'email' },
          // { text: '导师辅导', value: 'mentor' },
          { text: "删除", value: "delete", icon: "iconshanchujianli" },
        ];
      } else {
        this.pickerData = [
          {
            text: "修改简历名称",
            value: "setting",
            icon: "iconxiugaijianlimingcheng",
          },
          { text: "复制", value: "copy", icon: "iconfuzhijianli" },
          // { text: '预览分享', value: 'share' },
          // { text: '投递邮件', value: 'email' },
          // { text: '导师辅导', value: 'mentor' },
          { text: "删除", value: "delete", icon: "iconshanchujianli" },
        ];
      }
      this.operationPickerState = true;
      // this.$createPicker({
      // 	data: [ this.pickerData ],
      // 	onSelect: this.pickerChange
      // }).show()
    },
    // 选择picker
    async pickerChange(val) {
      // let value = val.join()
      let value = val.value;
      switch (value) {
        case "select":
          await this._dealOptions("selectCv");
          this.editType = "selectCv";
          this.editShow = true;
          break;
        case "cv":
          this.$fn.jump(`${window.location.origin}/cvs/${this.cv.token}/editor`,
          () => {
            this.$router.push(`/cvs/${this.cv.token}/editor`);
          });
          break;
        case "continue":
          this.continueShow = true;
          break;
        case "setting":
          this.settingShow = true;
          break;
        case "copy":
          this.duplicateCv(
            { cv_token: this.cv.token },
            "cvIndex",
            this.cv.lang
          );
          break;
        case "share":
          this.$fn.jump(`${process.env.VUE_APP_LINK}/cvs/${this.cv.token}/share`);
          break;
        case "email":
          this.$fn.jump(process.env.VUE_APP_LINK + this.cv.send_to_email_url)
          break;
        case "mentor":
          this.$fn.jump(`${window.location.origin}/service`)
          break;
        case "delete":
          this._deleteCv(this.cv.token);
          break;
        case "download":
          this.$fn.jump(`${window.location.origin}/cvs/send-email?token=${this.cv.token}&cv_name=${this.cv.cv_name}&hideProfile=false`, () => {
            this.$router.push(
              `/cvs/send-email?token=${this.cv.token}&cv_name=${this.cv.cv_name}&hideProfile=false`
            );
          })
          break;
      }
    },
    // 点击使用模板
    async cvByTemp(temp) {
      this.verifyLogin(
        this.logged,
        this._useTemp,
        `${process.env.VUE_APP_HOST}/cvs`,
        temp
      );
    },
    // 使用模板的接口方法
    _useTemp(temp, origin) {
      // 是否使用的是大牛简历模板
      if (origin && origin === "daniu") {
        this.$fn.jump(
          `${window.location.origin}/cvs/${temp.cv_token}/editor`,
          () => {
            this.$router.push(`/cvs/${temp.cv_token}/editor`);
          }
        );
      } else {
        this.$fn.jump(
          `${window.location.origin}/cvs/${
            temp[`${temp.currentLang}_token`]
          }/editor`,
          () => {
            this.$router.push(
              `/cvs/${temp[`${temp.currentLang}_token`]}/editor`
            );
          }
        );
      }
    },
    // 获取简历申请查看次数
    async _getAllApply() {
      if (this.logged) {
        try {
          let inboxData = await this.$api.inbox.getAllApply({
            page: 1,
            page_size: 10000,
          });
          if (inboxData.code === 1000) {
            this.count = inboxData.data.new_resume_hr_permission_count;
            this.applyCount = inboxData.data.resume_hr_permission_count;
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    // 已登录没有简历 简历模板放大按钮
    changeScaleStatus(temp) {
      this.scaleTemp = temp;
      this.scaleShow = true;
    },
    // 获取大牛简历案例
    async _getTemplateCase() {
      try {
        let res = await this.$api.templates.getTemplateCase({
          page: 1,
          size: 6,
        });
        if (res.code === 1000) {
          this.templateCase = res.data.sample_cvs;
          this.pageLoadingShow = false;
        }
      } catch (e) {
        console.error(e);
      }
    },
    // 修改简历名称后的回调
    refresh(value, type) {
      if (type === "changeName") {
        this.cv.cv_name = value;
      } else if (type === "editable") {
        this.cvList.forEach((item) => {
          item.can_editable = value.includes(item.token);
        });
      }
      this.operationPickerState = false;
    },
    // 老用户信息收集
    async oldUserInfoCollect() {
      if (!this.logged) return;
      let isOldUserInfoCollect = await this.getOldUserInfoCollectStatus();

      if (isOldUserInfoCollect) {
        this.$db.ss.set("isShowOldUserInfoCollect", true);
        this.$db.ls.set(
          `${this.cvAccountToken}-collectInfoTime`,
          new Date().getTime()
        );
        this.$router.push({
          path: "/template_matches/new",
          query: { isOldUserInfoCollect: true },
        });
      } else {
        if (this.$db.ss.get("isShowOldUserInfoCollect")) return;
        // this.isShowDownload();
      }
    },
    // 获取用户是否需要收集信息
    async getOldUserInfoCollectStatus() {
      let newUserLoginTimeInfo =
        this.$db.ls.get(`${this.cvAccountToken}-newUserLoginTime`) || null;
      // console.log('newUserLoginTimeInfo=', newUserLoginTimeInfo)
      let previousCollectInfoTime =
        this.$db.ls.get(`${this.cvAccountToken}-collectInfoTime`) || 0;
      let d = new Date();
      let currentTime = d.getTime(); // 当前时间
      if (newUserLoginTimeInfo && newUserLoginTimeInfo.newAccount) {
        let oneDay = 60 * 60 * 24 * 1000;
        if (currentTime - newUserLoginTimeInfo.loginTime < oneDay) {
          // 新注册用户的登录时间小于1天，不需要走 老用户信息收集 的逻辑
          console.log("没有满足老用户收集信息的条件");
          return false;
        }
        this.$db.ls.set(`${this.cvAccountToken}-newUserLoginTime`, {
          newAccount: false,
          loginTime: new Date().getTime(),
        });
      }
      let halfYearTime = 60 * 60 * 1000 * 24 * 182; // 半年时间
      if (
        this.userData.is_student != null &&
        currentTime - previousCollectInfoTime > halfYearTime
      ) {
        // 1、 已登陆状态 & 身份 或者 求职意向数据为空时
        if (!this.userData.intention) return true; // 求职意向

        // 2、已登录状态 & 学生身份 & 最近一段教育的毕业时间 早于当前
        if (this.userData.is_student) {
          let eduEndTimeResp = await this.$api.cv.getLastEduTime(
            this.cvAccountToken
          );
          console.log(eduEndTimeResp);
          if (eduEndTimeResp.code === 1000) {
            let eduEndTime = new Date(eduEndTimeResp.data.end_at).getTime();
            if (eduEndTime - currentTime < 0) {
              return true;
            }
          }
        }
        // 3、当前时间-简历最近更新时间>1年
        if (this.cvList && this.cvList.length) {
          let cvUpdateTime = new Date(this.cvList[0].update_time).getTime();
          let resultTime = currentTime - cvUpdateTime;
          let oneYearTime = 60 * 60 * 1000 * 24 * 365; // 1年时间
          if (resultTime > oneYearTime) {
            return true;
          }
        }
      }
      return false;
    },
    // 超级课程表登录
    superFriday() {
      let { access_token, open_id } = this.$route.query;

      // 已经调用过超级课程表授权了
      if (!!access_token && !!open_id) {
        this.$api.thirdParty
          .superFridayLogin({
            access_token,
            open_id,
          })
          .then((res) => {
            if (res.code === 1000) {
              let { jwt, jwt_timestamp } = res.data;
              if (!!jwt && !!jwt_timestamp) {
                // 更新jwt
                updateJWT({
                  jwt: jwt,
                  jwt_timestamp: jwt_timestamp,
                  cookieEndTime: moment().add(14, "d").valueOf(),
                });
                // 刷新页面
                location.reload();
              } else {
                this.showToast("授权登录失败");
              }
            } else {
              this.showToast("授权登录失败");
            }
          });
      } else {
        if (!Cookies.get("_t")) {
          window.location.href = `https://open.super.cn/authz/oauth/access_token?client_id=gtsJRQbMnW1AU9yTh5pa&client_secret=wAsfXPlq3zpuJFKUAzeH&callback=https%3A%2F%2Fm.wondercv.com%2Fcvs`;
        }
        // this.SuperFriday.Authorization = {
        //   client_id: 'gtsJRQbMnW1AU9yTh5pa',
        //   client_secret: 'wAsfXPlq3zpuJFKUAzeH',
        //   callback: `${process.env.VUE_APP_HOST}/cvs`,
        // }

        // this.$api.thirdParty.superFridayAuthorization({
        //   client_id: 'gtsJRQbMnW1AU9yTh5pa',
        //   client_secret: 'wAsfXPlq3zpuJFKUAzeH',
        //   callback: `${process.env.VUE_APP_HOST}/cvs`,
        // }).then(res => {
        //   this.SuperFriday.res = res;
        // }).catch(error => {
        //   this.SuperFriday.error = error;
        // })
      }
    },
    // 跳转支付宝小程序页面
    navigateAlipayMiniTo(options) {
      if (my) {
        my.navigateTo(options);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/global/variable";
@import "@/assets/scss/global/mixin";
@import "@/assets/scss/cv/cv-list";
/deep/ .cube-popup-mask {
  opacity: 0.5;
  color: #000;
}
.cv-wrapper {
  min-height: 100vh;
  background-color: #f9f9f9;
  box-sizing: border-box;
  @include ipx-content-bottom(49px);
  .download-img {
    width: 320px;
    position: relative;
    top: -20px;
  }
  .close-icon {
    margin-top: 8px;
    text-align: center;
    & > i {
      font-size: 35px;
      color: #fff;
    }
  }
  .banner-container {
    width: 100%;
    height: 152px;
    padding: 16px 24px 0;
    //margin-top: 12px;
    //margin: 10px 19px 0px;
    //margin-top: 10px;
    box-sizing: border-box;
    background-color: #fff;
  }

  .has-mentor {
    color: $color-title;
    font-size: $font-size-medium;
    height: 54px;
    font-weight: 400;
    padding: 0 16px;
    border-bottom: 10px solid #f5f5f7;
    box-sizing: border-box;
    .has-mentor-text {
      font-weight: 500;
    }
    img {
      width: 14px;
      margin-right: 10px;
    }
    button {
      width: 86px;
      height: 28px;
      font-size: $font-size-medium;
      font-weight: 400;
    }
  }
  .cv-description {
    background-color: #fff3df;
    .cv-msg {
      width: 100%;
      padding: 0 24px;
      height: 40px;
      color: #ff6644;
      .not-member-text {
        color: #4d4128;
        font-weight: 500;
      }
      img {
        width: 33px;
        height: 30px;
        object-fit: contain;
        margin-left: -10px;
        margin-top: 3px;
      }
      .member-btn {
        padding: 0 10px;
        //width: 64px;
        height: 22px;
        font-size: $font-size-small;
        color: #4d4128;
        background-color: transparent;
        border-radius: 18px;
        border: 1px solid #4d4128;
        font-weight: 500;
        // margin-right: 18px;
      }
      .iconx {
        color: #4d4128;
        font-weight: 600;
        font-size: 20px;
        margin-right: 14px;
      }
    }
  }
  .cv-operation {
    padding: 20px 24px 20px;
    background-color: $color-light;
    //margin-bottom: 14px;
    .operation-item {
      padding: 16px 0;
      &:last-child {
        border-top: 1px solid #f1f2f6;
      }
      .icon {
        margin-right: 18px;
        img {
          width: 42px;
          height: 42px;
        }
      }
      span {
        font-weight: 400;
        color: $color-title;
        font-size: $font-size-medium-x;
        &:last-child {
          font-size: $font-size-small;
          color: #9b9b9b;
          margin-top: 10px;
        }
      }
      .iconfont {
        font-weight: bold;
        color: $color-title;
      }
    }
  }
  .cv-container {
    //padding-top: 12px;
    background-color: $color-light;
    .cv-add {
      position: fixed;
      bottom: 120px;
      //bottom: 60px;
      right: 24px;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      z-index: 9;
      //background-color: $color-light;
      background-image: linear-gradient(#ff9f79, #ff6644);
      box-shadow: 0px 6px 8px 0px rgba(255, 102, 68, 0.18);

      .iconfont {
        color: $color-light;
        font-weight: 600;
        font-size: 18px;
      }
    }

    .cv-container-title {
      padding: 0 16px 18px;
      color: $color-title;
      font-size: $font-size-large;
      font-weight: bold;
      .sub-header {
        position: relative;
        width: 100%;
        .more {
          color: #9c9c9c;
          font-size: $font-size-medium;
          align-items: center;
          .iconfont {
            color: #9c9c9c;
            font-weight: bold;
            margin-left: 5px;
          }
        }
        .create-cv {
          font-size: $font-size-medium;
          color: #4183ff;
        }
        .create-card {
          position: absolute;
          z-index: 202;
          padding: 6px 26px;
          right: 0;
          top: 20px;
          background-color: $color-light;
          box-shadow: 0 2px 16px 0 rgba($color: #000000, $alpha: 0.06);
          border-radius: 4px;
          p {
            padding: 16px 0;
            border-bottom: 1px solid #f0f0f0;
            &:last-child {
              border: none;
            }
            span {
              font-size: $font-size-medium;
              line-height: 20px;
              color: $color-title;
            }
            .iconfont {
              color: $color-title;
              margin-right: 10px;
              font-weight: bold;
            }
            .iconfile-text {
              font-size: $font-size-large;
            }
          }
        }
      }
    }
    .more-cv-btn {
      height: 52px;
      color: #9c9c9c;
      line-height: 20px;
      border-top: 1px solid #f5f5f7;
      .iconfont {
        margin-left: 8px;
        font-weight: bold;
      }
    }
    .cv-btn-active {
      color: #4183ff;
    }
    .cv-temp-content {
      padding: 0 16px;
      margin-bottom: 24px;
      .cv-temp {
        box-shadow: 0 7px 19px 0 rgba(178, 178, 178, 0.13);
        border-radius: 6px;
        margin-bottom: 20px;
        border: 1px solid #f0f0f0;
        &:last-child {
          margin-bottom: 0;
        }
        .temp-container {
          background-color: $color-light;
          .temp-header {
            padding: 20px 18px;
            .title-wrapper {
              height: 26px;
              .temp-title {
                font-size: $font-size-medium-x;
                color: #424242;
                font-weight: bold;
              }
              .plus-icon {
                width: 16px;
                margin-left: 10px;
              }
            }
            .temp-btn {
              div {
                width: 46px;
                height: 26px;
                background-color: $color-light;
                border: 1px solid #50a4ff;
                color: #50a4ff;
                border-radius: 3px;
                font-size: $font-size-small;
                margin-right: 6px;
                &:last-child {
                  margin-right: 0;
                }
              }
              .is-active {
                background-color: #50a4ff;
                color: $color-light;
                border: none;
              }
            }
          }
          .temp-img {
            padding: 0 30px;
            position: relative;
            .temp-mask {
              width: 70vw;
              height: 100%;
              background-color: rgba(255, 255, 255, 0.5);
              position: absolute;
              top: 0;
              .use {
                width: 100px;
                height: 32px;
                border-radius: 2px;
                background-color: $color-theme;
                color: $color-light;
              }
            }
            img {
              width: 100%;
            }
          }
        }
        .temp-description {
          color: #7f8fa4;
          font-size: 13px;
          padding: 18px 26px;
          line-height: 22px;
        }
      }
    }
    .cv-loading-wrapper {
      width: 100vw;
      position: fixed;
      top: 50%;
      transform: translateY(-50%);
      img {
        width: 60px;
      }
    }
    .inbox {
      position: relative;
      .iconfont {
        font-weight: 400;
        font-size: 24px;
        color: $color-title;
      }
      .count {
        position: absolute;
        display: inline-block;
        top: 4px;
        right: 13px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        white-space: nowrap;
        padding: 0 6px;
        transform: translateY(-50%) translateX(100%);
        vertical-align: super;
        background-color: $color-theme;
        border-radius: 10px;
        color: $color-light;
        font-size: $font-size-small;
      }
    }
    .online-inbox {
      margin-bottom: 8px;
    }
  }
  .import-mask {
    position: fixed;
    width: calc(100vw - 16px);
    height: 76px;
    border-radius: 3px;
    top: 114px;
    left: 8px;
    box-shadow: rgba(0, 0, 0, 0.7) 0 0 0 100vh;
    z-index: 199;
    .import-content {
      position: absolute;
      top: 96px;
      color: $color-light;
      font-size: $font-size-large-x;
      font-weight: bold;
      line-height: 32px;
      padding-left: 16px;
      img {
        width: 46px;
        margin-right: 20px;
      }
      p {
        margin-bottom: -20px;
      }
    }
  }
  .setting-mask {
    position: fixed;
    top: 38px;
    right: 6px;
    width: calc(100vw - 12px);
    height: 190px;
    border-radius: 3px;
    box-shadow: rgba(0, 0, 0, 0.7) 0 0 0 100vh;
    z-index: 199;
    .cv-set-content {
      position: absolute;
      top: 210px;
      left: 40px;
      color: $color-light;
      font-size: $font-size-large;
      font-weight: 400;
      line-height: 28px;
      img {
        width: 46px;
        margin-bottom: 90px;
        margin-right: 18px;
      }
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: transparent;
    z-index: 201;
  }
  //.module-container {
  //  background-color: $color-light;
  //  padding: 24px;
  //  margin-bottom: 12px;
  //  .template-tags {
  //    padding: 16px 0 8px;
  //    overflow: hidden;
  //    .template-tag {
  //      display: inline-block;
  //      padding: 5px 10px;
  //      margin-right: 10px;
  //      border-radius: 12px;
  //      border: 1px solid #f0f0f0;
  //      color: #9c9c9c;
  //      &:last-child {
  //        margin-right: 0;
  //      }
  //    }
  //  }
  //  .cv-templates {
  //    flex-wrap: wrap;
  //    justify-content: space-between;
  //    .cv-template {
  //      margin-top: 16px;
  //      .temp-img-wrapper {
  //        width: 92px;
  //        height: 118px;
  //        border-radius: 4px;
  //        border: 1px solid #f0f0f0;
  //        margin-bottom: 12px;
  //        img[lazy=loading] {
  //          width: 36px;
  //        }
  //        img {
  //          width: 82px;
  //        }
  //      }
  //      .template-name {
  //        width: 92px;
  //        text-align: center;
  //        font-size: $font-size-small;
  //        line-height: 20px;
  //        color: $color-title;
  //      }
  //    }
  //  }
  //}
  .public-wrapper {
    padding: 0 16px;
    .public-container {
      font-weight: 500;
    }
  }
  //.module-title {
  //  margin-bottom: 16px;
  //}
  //.line-title {
  //  font-weight: 500;
  //  span {
  //    font-weight: 500;
  //  }
  //  &::before {
  //    content: '';
  //    display: inline-block;
  //    width: 2px;
  //    height: 12px;
  //    background-color: $color-theme;
  //    border-radius: 1px;
  //    margin-right: 8px;
  //  }
  //}
  //.temp-example {
  //  margin-bottom: 0;
  //  padding-bottom: 35px;
  //}
}
.page-loading-wrapper {
  background-color: $color-light;
}
.show-alipay-login-model {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}

.feedback-box {
  & {
    background: red;
  }
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 101;
  background: #ffffff;
  border-radius: 16px 16px 0px 0px;
  padding: 24px 24px 16px 24px;
  transition: all 1s;
  .iconGroup11 {
    position: absolute;
    top: 29px;
    right: 24px;
    font-size: 12px;
    color: #cfcfcf;
  }
  .feedback-title {
    font-size: 16px;
    font-weight: 500;
    color: #404040;
    line-height: 22px;
    margin-bottom: 30px;
  }
  .module-box {
    margin-top: 4px;
    margin-bottom: 8px;
    .module-box-title {
      font-size: 14px;
      font-weight: 500;
      color: #404040;
      line-height: 20px;
      margin-bottom: 12px;
    }
    .module-list {
      display: flex;
      flex-wrap: wrap;
      .module-item {
        padding: 6px 12px;
        font-size: 13px;
        font-weight: 400;
        color: #9c9c9c;
        line-height: 18px;
        background: #f9f9f9;
        border-radius: 16px;
        margin-right: 8px;
        margin-bottom: 8px;
        &.active {
          color: #ff6644;
          background: #fff6f4;
        }
      }
    }
  }
  .select-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    .option {
      width: 155px;
      height: 36px;
      border-radius: 18px;
      border: 1px solid #ececec;
      color: #9c9c9c;
      display: flex;
      align-items: center;
      justify-content: center;
      .iconfont {
        font-size: 14px;
        margin-right: 6px;
      }
      &.active {
        border: 1px solid #ff6644;
        color: #ff6644;
      }
    }
  }
  .content-box {
    width: 100%;
    height: 70px;
    background: #f9f9f9;
    border-radius: 6px;
    border: 1px solid #ececec;
    resize: none;
    box-sizing: border-box;
    padding: 10px;
    margin-bottom: 16px;
  }
  .sub-btn {
    width: 100%;
    height: 44px;
    background: #ff6644;
    border-radius: 6px;
    text-align: center;
    line-height: 44px;
    color: #fff;
    font-size: 16px;
    &.disable {
      color: #bcbcbc;
      background: #ececec;
    }
  }
  textarea {
    color: #404040;
  }
  textarea:focus {
    outline: #ececec;
  }
}
.adv-banner-container {
  width: 70vw;
  height: 100px;
  background: transparent;
}
.banner {
  margin-top: 12px;
  margin-bottom: 16px;
  width: 90vw;
  img {
    width: 100%;
  }
}
</style>
